new Vue({
  el: '#app',
  _scopeId: 'data-v-09520f58',
  owCSS: `.sso-app[data-v-09520f58]{--ola-primary-color:#424a54;--ola-highlight-color:#cddc39;--ola-back-color:#f5f5f5;--ola-front-color:#fff;--ola-label-color:#4d4d4d;--ola-text-color:#000;color:var(--ola-text-color);display:block;background:#f5f5f5;position:absolute;top:0;bottom:0;left:0;width:100%;min-height:480px;overflow:scroll;--mobile-cont:{max-width:550px;margin:0;display:block;left:0}@apply(--mobile-cont)}`,
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "sso-app"
    }, [_c('router-view', {
      staticClass: "view"
    }), _vm._v(" "), (_vm.owRegistry['sso-styles']) ? _c('sso-styles') : _vm._e(), _vm._v(" "), (_vm.owRegistry['ow-ga']) ? _c('ow-ga', {
      attrs: {
        "ga-key": _vm.gaKey
      }
    }) : _vm._e()], 1)
  },
  staticRenderFns: [],

  router: router,
  data: function data() {
    return {
      heading: "Ola Pilot",
      gaKey: window.owConfig.googleConfigs.gaKey
    };
  },

  mounted: function mounted() {
    var self = this;
    self.loadOWComponent('authentication', 'pages/authentication.js');
    self.loadOWComponent('sso-login', 'components/sso-login.js');
    self.loadOWComponent('sso-redirect', 'components/sso-redirect.js');
    self.loadOWComponent('sso-header', 'components/sso-header.js');
    self.loadOWComponent('sso-styles', 'components/sso-styles.js');
    self.loadOWComponent('logout', 'pages/logout.js');
    self.loadOWComponent('kyc', 'pages/kyc.js');
    self.loadOWComponent('kyc-full-kyc', 'pages/kyc-full-kyc.js');
    self.loadOWComponent('refreshtoken', 'pages/refreshtoken.js');
    self.loadOWComponent('2fa', 'pages/2fa.js');
    self.loadOWComponent('verify-email', 'pages/verify-email.js');
    self.loadOWComponent('reset-password', 'pages/reset-password.js');
    self.loadOWComponent('sso-bridge', 'components/sso-bridge.js');
    self.loadOWComponent('data-privacy', 'pages/data-privacy.js');
    self.loadOWComponent("manage-your-data", "pages/manage-your-data.js");

    Vue.nextTick(function() {
      self.loadOWComponent('ow-ajax', 'ow-components/ow-ajax.js');
      self.loadOWComponent('ow-dot-loader', 'ow-components/ow-dot-loader.js');
      self.loadOWComponent('ow-loader', 'ow-components/ow-loader.js');
      self.loadOWComponent('ow-top-loader', 'ow-components/ow-top-loader.js');
      self.loadOWComponent('ow-button', 'ow-components/ow-button.js');
      self.loadOWComponent('ow-icon', 'ow-components/ow-icon.js');
      self.loadOWComponent('ow-modal', 'ow-components/ow-modal.js');
      self.loadOWComponent('ow-dialog', 'ow-components/ow-dialog.js');
      self.loadOWComponent('ow-toast', 'ow-components/ow-toast.js');
      self.loadOWComponent('ow-select', 'ow-components/ow-select.js');
      self.loadOWComponent('ow-polling', 'ow-components/ow-polling.js');
      self.loadOWComponent('ow-ga', 'ow-components/ow-ga.js');
      self.loadOWComponent("native-bridge", "mixins/nativebridge.js");
      self.loadOWComponent("delete-acc", "components/delete-account.js");
    });

    window.onmessage = function(e) {
      console.log('received msg :', e.data);
      try {
        var msg = JSON.parse(e.data);
        if (msg && msg.lite_data) {
          console.log('lite params', msg.lite_data);
          window.params = msg.lite_data || {};
        }
        if (msg && msg.FKParams && msg.FKParams != null) {
          var sharedInfo = msg.FKParams.userInfo || msg.FKParams['auto-read'];
          Object.keys(sharedInfo).forEach(function(param) {
            window.populateFields(param, sharedInfo[param]);
          });
          if (msg.FKParams.grantToken) window.FKToken = msg.FKParams.grantToken;
        }
      } catch (ex) {
        console.log("Error in post message :  ", ex);
      }
    };
  }

});